export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10155.003124f2.jpg";